var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{staticClass:"admin-panel__dasboard__item__title-search",attrs:{"value":_vm.search,"append-icon":"mdi-magnify","label":"Search","single-line":"","hide-details":""},on:{"input":_vm.updateSearch}})
}
var staticRenderFns = []

export { render, staticRenderFns }